
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/watch/shared/[id]",
      function () {
        return require("private-next-pages/[locale]/watch/shared/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/watch/shared/[id]"])
      });
    }
  